const medicineProductBn = {
	breadcrumbs: {
		home: 'হোম',
		medicineBazar: 'মেডিসিন বাজার'
	},
	loading: 'লোড হচ্ছে...',
	labels: {
		prescriptionRequired: 'প্রেসক্রিপশন প্রয়োজন',
		reviewsSuffix: 'রিভিউ',
		deliveryPrefix: 'ডেলিভারি:',
		minOrderPrefix: 'সর্বনিম্ন অর্ডার:',
		perUnitPrefix: 'প্রতি',
		expiry: 'মেয়াদ শেষ:',
		stock: 'স্টক:',
		inStock: 'স্টকে আছে',
		outOfStock: 'স্টকে নেই',
		availableUnitsSuffix: 'মজুদ আছে',
		selectQuantity: 'পরিমাণ নির্বাচন করুন:',
		unitLabel: 'ইউনিট',
		unitStrip: 'স্ট্রিপ',
		unitBox: 'বক্স',
		unitTablet: 'ট্যাবলেট',
		unitBottle: 'বোতল',
		unitVial: 'ভায়াল',
		unitAmpule: 'অ্যাম্পুল',
		unitTube: 'টিউব',
		unitSachet: 'স্যাশে',
		unitInhaler: 'ইনহেলার',
		perUnitNotePrefix: '* প্রতি',
		totalAmountPrefix: 'মোট মূল্য:',
		addToCart: 'কার্টে যোগ করুন',
		wishlistAria: 'পছন্দের তালিকায় যোগ করুন',
		shareAria: 'শেয়ার করুন',
		descriptionTab: 'বিবরণ',
		specsTab: 'স্পেসিফিকেশন',
		reviewsTab: 'রিভিউ',
		productDescriptionTitle: 'ঔষধের বিবরণ',
		productSpecsTitle: 'ঔষধের স্পেসিফিকেশন',
		customerReviewsTitle: 'গ্রাহক রিভিউ',
		relatedTitle: 'সম্পর্কিত ঔষধসমূহ',
	},
	messages: {
		addedToCart: 'কার্টে যোগ করা হয়েছে!',
		orderInfo: 'আমাদের সকল ঔষধ লাইসেন্সপ্রাপ্ত ফার্মেসি থেকে সরবরাহ করা হয়...'
	}
};

export default medicineProductBn;


